import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle, XCircle, RefreshCw, MapPin } from "lucide-react";
import type { BranchStat } from "@/hooks/useClassTrialStats";

interface Props {
  branchStats: BranchStat[];
}

export function BranchStatsCards({ branchStats }: Props) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
      {branchStats.map((b) => (
        <Card key={b.branch}>
          <CardContent className="p-4">
            <div className="flex items-center gap-2 mb-2">
              <MapPin className="h-4 w-4 text-primary" />
              <span className="font-medium text-sm">{b.branch}</span>
              <span className="ml-auto text-lg font-bold">{b.total}</span>
            </div>
            <div className="flex gap-3 text-xs text-muted-foreground">
              <span className="flex items-center gap-1"><CheckCircle className="h-3 w-3 text-green-600" />{b.success}</span>
              <span className="flex items-center gap-1"><XCircle className="h-3 w-3 text-red-600" />{b.failure}</span>
              <span className="flex items-center gap-1"><RefreshCw className="h-3 w-3 text-purple-600" />{b.refund}</span>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
